import { useSelector } from "react-redux";
import { CATEGORIES_API } from "../../../Utilities/APIs";
import DINPTCRUD from "../../Partials/Layouts/CRUDs/CRUDLayouts/DINPTCRUD/DINPTCRUD";

function Category() {

  const {employee} = useSelector(state => state.auth)

  return (
    <DINPTCRUD
        // common props
        api={CATEGORIES_API}
        screenTopicSingular={'Category'}
        screenTopicPlural={'Categories'}
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowUpdate={employee.level === 'superAdmin'}
        allowCreate={employee.level === 'superAdmin'}
        allowDelete={employee.level === 'superAdmin'}
        
        // field props
        maxPrecedence={10}

        textDBField='engName'
        textName='English Name'
    />
  )
}

export default Category